import { AxiosInstance } from 'axios'
import { BeforeAfterItem, MediaObject } from '../types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface ServicesMainPageDto {
  data: {
    id: number
    attributes: ServicesMainPage
  }
}

interface ServicesMainPage {
  before_after_text?: BlocksContent
  before_afters?: {
    data: BeforeAfterItem[]
  }
  services_title: string
  decisions_placeholder: string
  direction_placeholder: string
  popular_services_title: string
  results_title: string
  main_image: MediaObject
}

export type GetServicesMainPageArgs = {
  locale: string
}

export const getServicesMainPage = async (client: AxiosInstance, { locale }: GetServicesMainPageArgs) => {
  const path = `/services-main-page`
  const params = {
    locale,
    fields: [
      'before_after_text',
      'decisions_placeholder',
      'direction_placeholder',
      'popular_services_title',
      'results_title',
      'services_title',
    ],
    populate: {
      main_image: { fields: ['*'] },
      before_afters: {
        populate: {
          before: '*',
          after: '*',
        },
      },
    },
  }
  return (await client.get<ServicesMainPageDto>(path, { params })).data.data.attributes
}
